const getCustListType = 'GET_CUST_LIST';
const getCurrentCustomerType = 'GET_CUST_CURRENT';
const setUserCustClaimType = 'SET_CUST_CLAIM';

const initialState = {
  current: null,
  all: []
};


//
// Base API calls
//
async function apiGet(url, getState){
  let objectReturned;
  await fetch(url, {
    method: 'GET',
    headers: new Headers({
      'Authorization': 'Bearer ' + getState().oidc.user.access_token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  }).then((response) => {
    if (response.status !== 200) {
      objectReturned = [];
    } else{
      objectReturned = response.json();
    }
  })
    .catch((error) =>{
      throw error;
    });
  return objectReturned;
}


async function apiPutPost(url, method, body, getState){
  let objectReturned;
  await fetch(url, {
    method: method,
    headers: new Headers({
      'Authorization': 'Bearer ' + getState().oidc.user.access_token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }),
    body: JSON.stringify(body)
  }).then((response) => {
    if (response.status !== 200) {
      objectReturned = [];
    } else{
      objectReturned = response.json();
    }
  })
    .catch((error) =>{
      throw error;
    });
  return objectReturned;
}


//
// Actions
//
export const actionCreators = {
  getAllCustomers: () => async (dispatch, getState) => {
    const url = `api/cfadmin/`;
    let userCustId = getState().oidc.user.profile.cdb_custid;
    let current = getState().admin.current;
    let currentCust, all;
    
    all = await apiGet(url, getState);
    let foundCust = all.find((cust) => cust.fileMakerId === userCustId);
    
    if (current === null){
      if(all.length === 0 || !foundCust){
        const url2 = `api/cfadmin/${userCustId}`;
        currentCust = await  apiGet(url2, getState);
      }else{
        currentCust = foundCust;
      }
    } 
    
    
    dispatch({type: getCustListType, all, currentCust})
  },
  getCurrentCustomer: () => async (dispatch, getState) => {
    let custId = getState().oidc.user.profile.cdb_custid;
    let all = getState().admin.all;
    const url = `api/cfadmin/${custId}`;
    let currentCust;
    
    let foundCust = all.find((cust) => cust.fileMakerId === custId);

    if(all.length === 0 || !foundCust){
      currentCust = await  apiGet(url, getState);
    }else{
      currentCust = foundCust;
    }
    dispatch({type: getCurrentCustomerType, currentCust})
  },
  setUserCustClaim: id => async (dispatch, getState) => {
    if (!id)
      return;

    const url = `api/cfadmin/changeid/${id}`;
    const method = 'PUT';
    const body = '';
    let newCurrentCust = await apiPutPost(url, method, body, getState);
    
    dispatch({type: setUserCustClaimType, newCurrentCust})
  }
};


//
// Reducer
//
export const reducer = (previousState, action) => {
  previousState = previousState || initialState;

  if (action.type === getCustListType) {
    return {
      ...previousState,
      all: action.all,
      current: action.currentCust
    }
  }
  if (action.type === getCurrentCustomerType){
    return {
      ...previousState,
      current: action.currentCust
    }
  } 
  if (action.type === setUserCustClaimType) {
    return {
      ...previousState,
      current: action.newCurrentCust
    }
  }

  return previousState;
};

